"use client";
import { useEffect, startTransition } from "react";

import GnpCounter from "./GnpCounter";
import GnpWindow from "./GnpWindow/GnpWindow";
import IGnpWindow from "./GnpWindow/IGnpWindow";

interface StatsProps {
    stats: any[];
}

export const Stats = ({ stats }: StatsProps) => {
    useEffect(() => {
        startTransition(() => {
            let w = window as unknown as IGnpWindow;
            w.gandp = w.gandp || new GnpWindow();
            w.gandp.counters = GnpCounter.activate(".counter_value");
        });
    }, []);

    return <div className="flex flex-row justify-center items-center font-bold py-[150px] max-w-full overflow-x-auto">
        <div className="flex sm:flex-row flex-col justify-around content-center justify-items-center gap-10">
            {
                stats.map((s, i) => {
                    return <div key={i} className="flex shrink flex-col justify-stretch items-center p-10 justify-content-stretch text-center">
                        <div className="flex flex-row align-self-start flex-nowrap counter_icon text-gdeepcopper sm:mb-10">
                            <i className={s.iconFontawesome + " text-[5rem] lg:text-[8rem]"}></i>
                        </div>
                        <div className="flex-col align-self-end flex-nowrap justify-content-between items-center content-center m-[25px 0] text-gdeepcopper">
                            <div className="text-[1.5rem] font-bold text-gash">{s.prefix}</div>
                            <div className="text-[3.5rem] my-3 text-center counter_value text-gcopper"
                                data-min={s.dataFrom}
                                data-max={s.dataTo}
                                data-step={s.dataSpeed}
                                data-transition_time="4000"
                                data-suffix=""
                                data-prefix=""
                                data-number_format="en-US"
                                data-delay_until_view="0"
                            ></div>
                            <div className="text-[1.5rem] font-bold text-gash">{s.suffix}</div>
                        </div>
                    </div>;
                })
            }
        </div>
    </div>;
};

export default Stats;